import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from '@providers/context/componenets/AuthContext'
import { Provider } from 'react-redux'
import { store } from '@store/store'
import App from '@router/App.jsx'
import '@/i18n/i18n'
import '@/styles/main.scss'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </Provider>
    </BrowserRouter>,
  </StrictMode>
)
